import { useTranslation } from "react-i18next";

import { Link } from "@/components/_molecules/navigation-controls/link";
import { useDocumentTitle } from "@/hooks/use-document-title";

import TwoFactorAuthForgottenForm from "../components/two-factor-auth-forgotten-form";

export function Forgot2FAPage() {
  const { t } = useTranslation("auth");
  useDocumentTitle(t("twoFactor.forgot.title"));

  return (
    <div className="flex h-screen w-screen items-center justify-center bg-background text-foreground">
      <div className="z-10 w-full max-w-md overflow-hidden rounded-sm border shadow-xl">
        <div className="flex flex-col items-center justify-center space-y-3 border-b px-4 py-6 pt-8 text-center sm:px-16">
          <h3 className="text-xl font-semibold">{t("twoFactor.forgot.title")}</h3>
          <p className="text-sm text-muted-foreground">
            {t("twoFactor.forgot.description")}
          </p>
        </div>

        <TwoFactorAuthForgottenForm />

        <p className="mb-8 text-center text-sm text-muted-foreground">
          {t("login.rememberCredentials")}{" "}
          <Link to="/login" className="font-semibold text-muted-foreground">
            {t("login.signIn")}
          </Link>{" "}
        </p>
      </div>
    </div>
  );
}
